/**
 * Dependencies:
 * - https://github.com/js-cookie/js-cookie
 * - template-engine.js
 *
 * changelog:
 * - 2022-10-14 - added api function consent_and_reload(). example: consent_and_reload('externalmedia');
 *              - added config option to switch between run_deferred_scripts() and reload_page() after consent was given
 *                (reload after consent would affect analytics results b/c referer would be lost)
 *
 */
$(function(){

	var cookie_name = 'cookieconsent',
		cookie_options_default = {
			expires: 365,
			sameSite: 'strict'
		},
		reload_after_consent = false;

	function setCookie(cookie_name, cookie_types_arr, cookie_options) {
		// cookie_options = (typeof cookie_options === 'undefined') ? [] : cookie_options;
		// Note: The $.merge() function is destructive. It alters the length and numeric index properties of the first object.
		cookie_options = $.merge((typeof cookie_options === 'undefined') ? [] : cookie_options, cookie_options_default);
		Cookies.set(cookie_name, cookie_types_arr.join('.'), cookie_options);
	}

	/**
	 * returns array with cookie types or false
	 * @param cookie_name
	 * @returns {boolean|string[]}
	 */
	function readCookie(cookie_name) {
		var value = Cookies.get(cookie_name);
		if (typeof (value) != 'undefined' && value !== '') {
			return value.split('.');
		} else {
			return false;
		}
	}

	var cookieconsent_id = 'cookieconsent',
		cookieconsent = $('#' + cookieconsent_id),
		cookieconsent_open_class = 'cookieconsent-open',
		cookieconsent_page_scroll_lock_class = 'cookieconsent-no-scroll',
		cookieconsent_cookietable_class = 'cookieconsent-cookietable',
		_;


	function repair_focus () { // focused_class zuweisen, weil das standard .focus() nicht klappt (warum nicht?)

		var focused_class = 'focused';

		cookieconsent.on('click', 'label, button', function(){
			var self = $(this),
				checkboxes = cookieconsent.find('input[type="checkbox"]').not(':disabled');
			checkboxes.removeClass(focused_class);
			if (self.is('label')) {
				var id = self.attr('for');
				checkboxes
					.filter('#' + id)
					.addClass(focused_class)
				;
			}
			// $('input[type="checkbox"][').focus();
			// console.log($('input[type="checkbox"][name="' + name +'"]'));
		});

	}

	function handle_link_goto_page_clicks () {

		var
			cookieconsent_link_class = 'cookieconsent-link-goto', // cookieconsent-link-goto-details',
			cookieconsent_page_class = 'cookieconsent-page',
			cookieconsent_page_active_class = 'cookieconsent-page-active',
			cookieconsent_link_hidden_class = 'cookieconsent-link-goto-hidden', // cookieconsent-link-goto-hidden-main
			cookieconsent_page_id_data_key = 'cookieconsent-page-id',
			_;

		// -----------------------------------------------------------------------------------------------------------------
		// handle clicks on goto page links / buttons
		$('#' + cookieconsent_id).on('click', '.' + cookieconsent_link_class, function (e) {
			var target_page_id = $(this).data(cookieconsent_page_id_data_key);
			// hide all pages
			$('.' + cookieconsent_page_class).removeClass(cookieconsent_page_active_class)
			// show target page
			$('.' + cookieconsent_page_class + '-' + target_page_id).addClass(cookieconsent_page_active_class);

			// collect all ids
			/*
			var ids = [];
			$('.' + cookieconsent_link_class).each(function(){
				ids.push($(this).data(cookieconsent_page_id_data_key));
			});
			*/
			// show all buttons
			var all_buttons = $('.' + cookieconsent_link_class);
			// console.log(all_buttons);
			all_buttons.removeClass(cookieconsent_link_hidden_class);
			all_buttons.each(function () {
				var self = $(this);
				// console.log(cookieconsent_link_hidden_class + '-' + target_page_id);
				if (self.hasClass(cookieconsent_link_hidden_class + '-' + target_page_id)) { // e.g. cookieconsent-link-goto-hidden-privacy, which means: hide when page privacy is active

					self.addClass(cookieconsent_link_hidden_class);
				}
			});
			//
			// console.log($('.' + cookieconsent_page_class + '-' + target_page_id));
		});

	}


	// -----------------------------------------------------------------------------------------------------------------
	// load external text via ajax (privacy policy)

	function replaceHeadline(content, tagName) {
		content.find(tagName).each(function(){
			var h = $(this);
			h.replaceWith($('<div class="page-headline-' + tagName + '">').append(h.contents()));
		});
		return content;
	}

	function load_external_content () {
		var target_container = $('.cookieconsent-load-content'),
			source_filename = target_container.data('source-url'),
			source_selector = target_container.data('source-selector'),
			source_remove_selector = target_container.data('source-remove'),
			source_error_class = target_container.data('source-error-class'),
			_;
		if (target_container.length && source_filename !== '' && source_selector !== '') {
			// console.log(source_filename);

			/*
			$.get(source_filename, function (data) {
				var content = $('.' + source_selector, data);
				target_container.html(content);
				// console.log('ajax load successful ...');
			});
			*/

			$.get(source_filename)
				.done(function (data) {
					var content = $(source_selector, data);
					// optionally remove elements
					if (source_remove_selector !== '') {
						content.find(source_remove_selector).remove();
					}
					content = replaceHeadline(content, 'h1');
					content = replaceHeadline(content, 'h2');
					content = replaceHeadline(content, 'h3');
					content = replaceHeadline(content, 'h4');
					content = replaceHeadline(content, 'h5');
					content = replaceHeadline(content, 'h6');
					target_container.html(content);
				})
				.fail(function () {
					// target_container.html('<p>Das Laden der Ressource ist fehlgeschlagen. Bitte versuchen Sie es erneut.</p>');
					target_container.append($('.' + source_error_class).html());
				})
			// .always(function() {
			// 	alert( "finished" );
			// })
			;

		}
	}



	// -----------------------------------------------------------------------------------------------------------------
	// create cookietable for detail page

	/*
	function htmlDecode(input) {
		var doc = new DOMParser().parseFromString(input, "text/html");
		return doc.documentElement.textContent;
	}
	*/

	function create_cookietables () {

		var	cookieconsent_cookietable_section_wrapper_class = 'cookieconsent-cookietable-section-wrapper',
			cookieconsent_cookietable_section_class = 'cookieconsent-cookietable-section';

		if (COOKIECONSENT_GROUPS.length) {

			var section_wrapper = $('.' + cookieconsent_cookietable_section_wrapper_class),
				template_site_entry = section_wrapper.find('.cookieconsent-tmpl-cookie-sites-entry').html(),
				template_table_row = section_wrapper.find('.cookieconsent-tmpl-cookietable-row').html();

			$.each(COOKIECONSENT_GROUPS, function(i, cookie_group){

				var section = $('<div class="' + cookieconsent_cookietable_section_class + '"></div>');
				section.append($('<p class="cookieconsent-cookietable-section-heading"><strong>' + cookie_group.name + '</strong></p>'));
				if (typeof cookie_group.description !== 'undefined' ) {
					section.append($('<p class="cookieconsent-cookietable-section-description">' + cookie_group.description + '</p>'));
				}


				$.each(COOKIECONSENT_SITES, function (i, site) {

					if (site.type===cookie_group.type) {

						var site_entry_markup = $(TemplateEngine(template_site_entry, site));
						section.append(site_entry_markup);

					}

				var table_header_html = $('.cookieconsent-tmpl-cookietable-header').html(),
					table_wrapper = $(table_header_html); // == <table>

					var c = 0;

					$.each(COOKIECONSENT_COOKIES, function (i, cookie) {

						if (cookie.type===cookie_group.type && site.id===cookie.id) {

						// console.log(cookie);
						var table_row = $(TemplateEngine(template_table_row, cookie));
						// console.log(table_row);
						table_wrapper.append(table_row); // append to <table>



							c++;

					}

				});

					if (c!==0) {

				section.append(table_wrapper);
				section_wrapper.append(section);

					}

				});

			});

		}

	}

	function create_cookie_sites_details () {

		var	cookieconsent_cookie_sites_section_wrapper_class = 'cookieconsent-cookie-sites-section-wrapper',
			cookieconsent_cookie_sites_section_class = 'cookieconsent-cookie-sites-section';

		if (COOKIECONSENT_GROUPS.length) {

			var section_wrapper = $('.' + cookieconsent_cookie_sites_section_wrapper_class),
				template_site_entry = section_wrapper.find('.cookieconsent-tmpl-cookie-sites-entry').html();

			$.each(COOKIECONSENT_GROUPS, function(i, cookie_group) {

				var section = $('<div class="' + cookieconsent_cookie_sites_section_class + '"></div>');
				section.append($('<p class="cookieconsent-cookie-sites-section-heading"><strong>' + cookie_group.name + '</strong></p>'));

				var sites_entries_container = $('<div class="cookieconsent-cookie-sites-entries"></div>');

				var c = 0;

				$.each(COOKIECONSENT_SITES, function (i, site) {

					if (site.type===cookie_group.type) {

						var site_entry_markup = $(TemplateEngine(template_site_entry, site));
						sites_entries_container.append(site_entry_markup);

						// console.log(site_entry_markup.html());

						c++;

					}

				});

				if (c!==0) {

					section.append(sites_entries_container);
					// console.log(section.html());
					section_wrapper.append(section);

				}

			});

		}

	}

	// -----------------------------------------------------------------------------------------------------------------

	/**
	 * generates the checkboxes; if cookie_types given, set checkbox state accordingly
	 * @param cookie_types = defines which checkboxes are actually checked
	 */
	function generate_checkboxes (cookie_types) {

		var tmpl = $('.cookieconsent-tmpl-checkbox').html(),
			cookieconsent_checkbox_wrappers_class = 'cookieconsent-checkbox-wrappers',
			cookieconsent_checkbox_wrappers = $('.' + cookieconsent_checkbox_wrappers_class),
			cookieconsent_checkbox_class = 'cookieconsent-checkbox';

		cookieconsent_checkbox_wrappers.empty();

		$.each(COOKIECONSENT_GROUPS, function(i, cookie_group) {

			var checkbox_element = $(TemplateEngine(tmpl, cookie_group));
			cookieconsent_checkbox_wrappers.append(checkbox_element);

		});

		// set checkboxes according to cookie_types parameter (which comes from the actual cookie)
		if (typeof(cookie_types!=='undefined')) {

			// console.log(cookie_types);

			/*
			$.each(cookie_types, function(i, cookie_type) {
				cookieconsent.find('#cookie_checkbox_' + cookie_type)
			});
			*/
			cookieconsent_checkbox_wrappers.find('.' + cookieconsent_checkbox_class).each(function(){
				var self = $(this);
				if ($.inArray(self.data('cookieconsent-type'), cookie_types)===-1) {
					// console.log(self.data('cookieconsent-type'));
					self.prop('checked', false);
				} else {
					self.prop('checked', true);
				}
			});
			// always set required cookie checkbox to checked
			cookieconsent_checkbox_wrappers.find('#cookie_checkbox_required').prop('checked', true);

		}

	}



	// -----------------------------------------------------------------------------------------------------------------

	function enhance_table_rwd () {

		var table = cookieconsent.find('.' + cookieconsent_cookietable_class),
			headlines = [];

		// get table header headlines
		table.find('tr > th').each(function () {
			headlines.push($(this).html());
		});

		table.find('tr > td').each(function () {
			var self = $(this),
				index = self.index();
			self.prepend('<span class="cookieconsent-cookietable-col-headline">' + headlines[index] + '</span>');
		});

	}


	// -----------------------------------------------------------------------------------------------------------------

	function handle_confirm_button_clicks () {

		var cookieconsent_checkbox_class = 'cookieconsent-checkbox';

		cookieconsent.on('click', '.cookieconsent-btn-confirm', function () {

			var checkboxes_all = cookieconsent.find('.' + cookieconsent_checkbox_class),
				cookie_types_arr = [];

			if ($(this).hasClass('cookieconsent-btn-confirm-all')) {
				checkboxes_all.prop('checked', true);
			}
			checkboxes_all.filter(':checked').each(function(){
				cookie_types_arr.push($(this).data('cookieconsent-type'));
			});
			setCookie(cookie_name, cookie_types_arr);

			// close window
			close_cookieconsent();

			// run deferred scripts:
			if (reload_after_consent) {
				reload_page();
			} else {
			run_deferred_scripts(cookie_types_arr);
			}

		});

	}

	// -----------------------------------------------------------------------------------------------------------------

	function body_scroll_lock () {
		$('html, body').addClass(cookieconsent_page_scroll_lock_class);
	}
	function body_scroll_unlock () {
		$('html, body').removeClass(cookieconsent_page_scroll_lock_class);
	}

	function close_cookieconsent () {
		cookieconsent.removeClass(cookieconsent_open_class);
		body_scroll_unlock();
	}

	// open cookieconsent layer
	function open_cookieconsent () {

		var cookie_types;

		// read cookie, because it could have been changed since
		if (cookie_types = readCookie(cookie_name)) {
			// cookie is already set
			update_cookieconsent(cookie_types);
		} else {
			// cookie not set yet
		}
		$(cookieconsent).addClass(cookieconsent_open_class);
		body_scroll_lock();

	}

	// update cookieconsent layer ui
	function update_cookieconsent (cookie_types) {
		generate_checkboxes(cookie_types);
	}





	// -----------------------------------------------------------------------------------------------------------------
	/**
	 * activate prepared inactive javascripts
	 * @param id
	 */
	function activateScriptByConsentId(id) {
		var dataAttrExternalStr = 'consent-original-source',
			dataAttrInline = 'consent-inline';
		$('script[data-consent-id="' + id + '"]').each(function(){
			var s = $(this);
			if (s.data('consent-required') === 'required') {
				var c_org_type = s.data('consent-original-type');
				if (s.is('[data-' + dataAttrExternalStr + ']')) { // external scripts
					s.attr('type', c_org_type);
					var c_org_src = s.data(dataAttrExternalStr);
					if (c_org_src && c_org_src !== '') {
						s.attr('src', c_org_src);
					}
				} else if (s.is('[data-' + dataAttrInline + ']')) { // inline scripts
					var h = decodeURIComponent(s.data(dataAttrInline));
					s.html(h);
					var s_new = $('<scr' + 'ipt></scr' + 'ipt>').html(h);
					s_new.attr('type', c_org_type);
					$('head').append(s_new);
				}
				s.data('consent-required', '');
			}
		});
	}






	// -----------------------------------------------------------------------------------------------------------------
	/**
	 * run javascripts according to cookie settings
	 * run at most the scripts, which haven't been run before
	 * @param cookie_types_arr = Array with currently allowed cookie types
	 */
	function run_deferred_scripts(cookie_types_arr) {

        // var t = cookie_types.join('.');
        // a(o, t);
        for (var n=0; n<COOKIECONSENT_DEFER.length; n++) {
            var deferred_script = COOKIECONSENT_DEFER[n];
            if ($.inArray(deferred_script.type, cookie_types_arr)!==-1) {
				// console.log('run ' + deferred_script.name);
	            if (typeof(deferred_script.init)==='function') {
		            deferred_script.init();
	            } else if (typeof(deferred_script.id)!=='undefined') {
					activateScriptByConsentId(deferred_script.id);
	            }
            	deferred_script.didRun = true;
            }
        }
        // remove scripts, that have already run, from the list - so they cannot be run more than once
		// so, when run_deferred_scripts() is called more than once (e.g. when opening the cookieconsent layer
		// manually), a settings change will only run the scripts, which have not been run before
        COOKIECONSENT_DEFER = COOKIECONSENT_DEFER.filter(function(e) {
            return !e.didRun;
        })
    }


	function reload_page () {

		window.location.reload();

	}




	function append_ccm_to_dom () {

		var html = $('#cookieconsent_tmpl').html();
		$(html).appendTo('body');

	}




	function consent_and_reload (cookie_group_id) {

		var cookie_types_arr = readCookie(cookie_name);
		if (!Array.isArray(cookie_types_arr)) {
			cookie_types_arr = [];
		}
		console.log(cookie_types_arr);
		if ($.inArray(cookie_group_id, cookie_types_arr)===-1) {
			// cookie_types_arr.push('required'); // always consent to 'required' cookies, b/c they are required
			cookie_types_arr.push(cookie_group_id); // ::todo:: check if given cookie_group_id exists
			setCookie(cookie_name, cookie_types_arr);
		}
		window.location.reload();

	}



	// -----------------------------------------------------------------------------------------------------------------

	// mandatory stuff

	create_cookietables();   // cookie details table
	load_external_content(); // privacy policy
	repair_focus();          // checkbox and button focus styling stuff
	generate_checkboxes();
	enhance_table_rwd();

	handle_link_goto_page_clicks();
	handle_confirm_button_clicks();

	// main

		var cookie_types,
			cookie_types_arr;
		if ((cookie_types_arr = readCookie(cookie_name)) && $.inArray('required', cookie_types_arr)!==-1) {
		// cookie already set -> do not open cookieconsent layer
		// run deferred scripts:
		run_deferred_scripts(cookie_types_arr);
	} else {
		open_cookieconsent();
	}

	// expose api:
	window.CookieConsent = {};
	CookieConsent.open = open_cookieconsent;
	CookieConsent.consentAndReload = consent_and_reload;





});

